module.exports = __webpack_public_path__ + "img/hochmut.b1dedf5e.png";